// extracted by mini-css-extract-plugin
export var actionContainer = "index-module--actionContainer--5dO0-";
export var actionContent = "index-module--actionContent--ijRp+";
export var actionNumber = "index-module--actionNumber--ZGcCq";
export var actionTitle = "index-module--actionTitle---t0Ia";
export var actionsWrapper = "index-module--actionsWrapper--XbZxb";